<script>
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import FileUploader from '../shared/file-uploader/FileUploader';
import { BusinessHours } from '../../models/BusinessHours';
import utils from '@/services/xml-rpc/utils';
const checkedIcon = require('../../assets/starface_icons_png/24/orange/checkbox_on.png');
const uncheckedIcon = require('../../assets/starface_icons_png/24/orange/checkbox_off.png');
const daysOfTheWeek = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

export default {
  name: 'BusinessHours',
  components: {
    ButtonIconLeft,
    FileUploader
  },
  props: {
    moduleData: {
        type: BusinessHours,
        required: true,
    },
  },
  data() {
    return {
      announcementConfig: {
          title: '',
          intro: `Lade hier Eure Ansage („Sie rufen außerhalb unserer Geschäftszeiten an…“) hoch! Eure Ansage wird bei eingehenden
          Anrufen im oben angegebenen Zeitraum automatisch abgespielt.
          <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Geschaeftszeitenregelung" target="_blank">Mehr Info</a>`,
          file: {
              type: '.wav',
              selected: false
          },
          info: {
              preFileText: '',
              fileName: '',
              selectedFile: ''
          }
      },
      announcementAudioFile: null,
      announcementTimes: [],
      businessHoursActive: false,
    };
  },
  created() {
    this.convertModuleTimesToComponentTimes();
    this.setInitialActiveStatus();
  },
  methods: {
    addSpeachSystemKey() {
        this.announcementTimes.push({
            days: [false, false, false, false, false, false, false],
              von: '00:00',
              bis: '23:59',
          });
    },
    deleteTimeRow(index) {
      this.announcementTimes.splice(index, 1);
    },
    changeDayStatus(index, dayIndex) {
      this.announcementTimes[index].days.splice(dayIndex, 1, !this.announcementTimes[index].days[dayIndex]);
    },
    convertComponentTimesToModuleTimes() {
      const moduleTimes = [];
      this.announcementTimes.forEach( time => {
        time.days.forEach( (day, index) => {
          const dayOfTheWeek = daysOfTheWeek[index];
          const timeOfAnnouncement = day ? time.von + '-' + time.bis : '00:00-00:00';
          moduleTimes.push(dayOfTheWeek + ' ' + timeOfAnnouncement);
        });
      });
      return moduleTimes;
    },
    convertModuleTimesToComponentTimes() {
      if (this.moduleData.GUI_ZEITRAEUME_DER_UMLEITUNG) {
        const timeRows = this.createChunksFromArray(this.moduleData.GUI_ZEITRAEUME_DER_UMLEITUNG, 7);
        timeRows.forEach( timeRow => {
          const arrayEntry = this.createNewBusinessHourEntry();
          timeRow.forEach( time => {
            const dividiedString = time.split(' ');
            const devidedTime = dividiedString[1].split('-');
            const businessHoursEntriesNotExist = devidedTime[0] === '00:00' && devidedTime[1] === '00:00';
            if (businessHoursEntriesNotExist) {
              arrayEntry.days.push(false);
            } else {
              arrayEntry.days.push(true);
              arrayEntry.von = devidedTime[0];
              arrayEntry.bis = devidedTime[1];
            }
          });
          this.announcementTimes.push(arrayEntry);
        });
      }
    },
    createNewBusinessHourEntry() {
      return {
        days: [],
        von: '00:00',
        bis: '00:00'
      };
    },
    createChunksFromArray(arrayToSplit, splitNumber) {
      const chunks = [];
      let index = 0;
      while (index < arrayToSplit.length) {
        chunks.push(arrayToSplit.slice(index, index += splitNumber));
      }
      return chunks;
    },
    checkedIconRet(icon) {
      switch (icon) {
          case 'check':
              return checkedIcon;
          case 'uncheck':
              return uncheckedIcon;
          default:
              return uncheckedIcon;
      }
    },
    uploadAnnouncementFile(event) {
      const file = event.target.files[0];
      if (file) {
          this.announcementConfig.file.selected = true;
          this.announcementConfig.info.selectedFile = file.name;
          utils.getBase64(file).then(
              data => {
                  this.announcementAudioFile = data;
                  this.emitDataToParent();
              }
          );
      }
    },
    setInitialActiveStatus() {
      if (this.moduleData.INSTANCE_ENABLED) {
        this.businessHoursActive = this.moduleData.INSTANCE_ENABLED;
      }
    },
    toggleBusinessHours() {
      this.businessHoursActive = !this.businessHoursActive;
      this.emitDataToParent();
    },
    emitDataToParent() {
      this.$emit('sendBusinessHoursData', {audio: this.announcementAudioFile, times: this.convertComponentTimesToModuleTimes(), status: this.businessHoursActive});
    }
},
watch: {
  announcementTimes: {
    deep: true,
      handler() {
        this.emitDataToParent();
      }
    }
  }
};
</script>

<template>
  <div class="business-hours">
    <div class="active-status" @click="toggleBusinessHours()">
      <div v-if="this.businessHoursActive">
        <img
          src="@/assets/starface_icons_png/24/orange/checkbox_on.png"
          alt="Status active" style="width:16px"
        />
        <b>Abwesenheitszeiten aktivieren</b>
      </div>
      <div v-else>
        <img
          src="@/assets/starface_icons_png/24/orange/checkbox_off.png"
          alt="Status active" style="width:16px"
        />
        Abwesenheitszeiten aktivieren
      </div>
    </div>
    <div v-if="this.businessHoursActive">
    <div class="intro">
      Kommuniziere Eure Arbeitszeiten bei eingehenden Anrufen außerhalb der Geschäftszeiten. Lege die Abwesenheitszeiten fest und lade anschließend eine Ansage im WAV Format hoch.
    </div>

    <div class="business-hours-table">
      <table>
        <tr>
          <th>Mo</th>
          <th>Di</th>
          <th>Mi</th>
          <th>Do</th>
          <th>Fr</th>
          <th>Sa</th>
          <th>So</th>
          <th>Von</th>
          <th>Bis</th>
          <th></th>
        </tr>
        <tr v-for="(entry, index) in announcementTimes" :key="index">
          <td class="day" v-for="(day, dayIndex) in entry.days" :key="dayIndex" @click="changeDayStatus(index, dayIndex)">
            <img
              :src="day ? checkedIconRet('check') : checkedIconRet('uncheck')"
              :alt="day ? 'Status active' : 'Status inactive'"
            />
          </td>
          <td class="day">
            <input
              class="table-number-input"
              v-model="entry.von"
            />
          </td>
          <td class="day">
            <input
              class="table-number-input"
              v-model="entry.bis"
            />
          </td>
          <td>
            <ButtonIconLeft
              class="btn-edit"
              @onClick="deleteTimeRow(index)"
              buttonTitle="löschen"
              src="delete"
              cssClass="btn btn-tertiary"
            />
          </td>
        </tr>
      </table>

      <div class="table-footer">
        <ButtonIconLeft
          class="btn-add"
          @onClick="addSpeachSystemKey()"
          buttonTitle="Hinzufügen"
          src="add"
          :disabled="announcementTimes.length === 9"
          cssClass="btn btn-primary"
        />
      </div>
    </div>
    <FileUploader :config="announcementConfig" @uploadFile="uploadAnnouncementFile"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
.business-hours {
  color: $grey-dark;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  .active-status {
    display: flex;
    cursor: pointer;
    padding-top: 20px;
    padding-bottom: 28px;
    align-items: baseline;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }

  .business-hours-table {
    table {
      grid-row: 2;
      justify-self: start;
      text-align: left;
      border-spacing: 0;
      padding: 16px 0;
      width: 100%;
      font-size: 18px;
      tr {
        height: 48px;
        &:nth-child(odd) {
          background-color: white;
        }
      }
      th {
        color: white;
        font-weight: bold;
        background-color: $th-background-color;
        padding: 6px 16px;
        text-align: center;
      }
      td {
        padding: 6px 16px;
        text-align: center;
        &.day {
          cursor: pointer;
          width: 98px;
          img {
            width: 16px;
          }
        }
      }
      .btn-edit {
        float: right;
      }

      .table-number-input {
        width: 80px;
        font-size: 18px;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 2px;
        border: 1px solid #dbdbdb;
        color: #676767;
        height: 30px;
        padding: 0 10px 0 10px;
      }
      .table-number-input:focus,
      input:focus,
      input[type]:focus,
      .uneditable-input:focus {
        border: 1px solid orange;
        outline: 0 none;
      }
    }
    .table-footer {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-top: 8px;
      padding-bottom: 32px;
      .btn-add {
        width: 142px;
        height: 34px;
      }
      .btn:disabled {
        opacity: 1;
        background: $grey-light;
        border: $grey-light;
        color: #fff;
      }
    }
  }
}
</style>
